export function firstFocusableChildrenOf(el: HTMLElement): HTMLElement | null {
  return el.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
}
